import cronstrue from 'cronstrue'
import cronParser from 'cron-parser'
export const cronToBasic = cron => {
  const vals = cron.split(' ')
  return `0 ${vals[1]} ${vals[2]} * * ?`
}

export const describeCron = cronExpression => {
  try {
    cronParser.parseExpression(cronExpression)
    return { success: true, description: cronstrue.toString(cronExpression) }
  } catch (e) {
    return { success: false, description: e.message }
  }
}
